import React from "react";
import Loader from "../Loader";
import MessageBox from "../MessageBox";
import circle from "../../assets/svgs/Ellipse.svg";
import polygon from "../../assets/svgs/Polygon.svg";
import addActivityIcon from "../../assets/svgs/add-activity-pulse.svg";

const UpdateTab = ({ activitydata, loading, hasMore, parentLoading }) => {
  return (
    <div>
      <div>
        {activitydata?.length !== 0 && activitydata !== undefined ? (
          activitydata?.flatMap(({ date, data }, idx) => (
            <div key={idx} className="px-6 updates-date-info">
              <div className="pb-8 relative">
                <img src={circle} alt="icon" className="absolute top-2.5 -left-[30px]" />
                <div className="flex" style={{ marginLeft: "-12px" }}>
                  <img src={polygon} alt="icon" />
                  <p className="date dark-M body-S" style={{ backgroundColor: "#edf0eb" }}>
                    {date}
                  </p>
                </div>
                <div className="pl-4">
                  {data.map((activity) => (
                    <MessageBox key={activity?.id} activity={activity} activityId={activity?.id} />
                  ))}
                </div>
              </div>
            </div>
          ))
        ) : (
          !loading && !parentLoading && (
            <div className="flex flex-col items-center justify-center py-12 mt-6 bg-white rounded-xl">
              <img src={addActivityIcon} alt="No Updates" className="w-16 h-16 mb-4 opacity-60" />
              <p className="head-4 dark-H mb-2">No Updates Available</p>
              <p className="body-N dark-M mb-6">There are no updates matching your search.</p>
            </div>
          )
        )}

        {!hasMore && activitydata?.length !== 0 && <p className="text-center dark-M mt-6 body-S">End of Timeline</p>}
      </div>

      {loading && !parentLoading && <Loader />}
    </div>
  );
};

export default UpdateTab;
